import Modal from 'react-bootstrap/Modal';
import { useState } from 'react';
import { fetchFromApi } from '../../config/api';
import API_ENDPOINTS from '../../config/apiConfig';
import { useData } from '../../context/DataContext';

function EditCategoriesModel(props) {
    const { fetchCategoriesData } = useData();
    const [category, setCategory] = useState(props.editData.category_name || "");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!category.trim()) { setError("Category name cannot be empty"); return; }
        setLoading(true);
        setError("");
        try {
            const data = await fetchFromApi(API_ENDPOINTS.CATEGORIES_UPDATE, 'POST', {
                id: props.editData.id,
                category_name: category.trim(),
            });
            if (data.status === "success") {
                setSuccessMsg("Category updated successfully!");
                setTimeout(async () => {
                    setSuccessMsg(""); props.onHide(); await fetchCategoriesData();
                }, 1500);
            } else {
                setError(data.message || "Failed to update category.");
            }
        } catch {
            setError("An error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal {...props} size="sm" centered>
            <Modal.Header closeButton>
                <Modal.Title>Edit Category</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSubmit}>
                    <div className="form-field">
                        <label htmlFor="cat-edit-name">Category Name <span className="req">*</span></label>
                        <input
                            id="cat-edit-name"
                            type="text"
                            value={category}
                            onChange={(e) => { setCategory(e.target.value); setError(""); }}
                            className={error ? 'is-error' : ''}
                            disabled={loading}
                            autoFocus
                        />
                        {error && <span className="field-error">{error}</span>}
                    </div>
                    {successMsg && (
                        <div className="modal-alert success">
                            <i className="fa-solid fa-circle-check"></i> {successMsg}
                        </div>
                    )}
                </form>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn-primary-orange" onClick={handleSubmit} disabled={loading}>
                    {loading ? "Updating…" : "Update Category"}
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export default EditCategoriesModel;
